import React from "react"

// Mui
import { Box, Stack, Typography, useTheme } from "@mui/material"

// Next Image
import Image from "next/image"

// Images
import Rocket from "public/images/icons/rocket.png"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"

// Images
import Image1 from "public/images/icons/1.png"
import Wallet from "public/images/icons/wallet2.png"
import Location from "public/images/icons/location.png"
import Clock from "public/images/icons/wall-clock.png"
import MainCard from "../../../../common/main-card"

// ---------------------------------------------------------------------------------------------------------------------

const MobileSimplifyBorrowing = () => {
  const theme = useTheme()

  const items = [
    {
      image: Wallet,
      title: "با ارائه ضامن ",
      subTitle: "به همراه یک برگ چک صیادی"
    },
    {
      image: Clock,
      title: "صرفه جویی در زمان",
      subTitle: "کل فرآیندهای گرفتن وام رو با سرعت جت طی کن"
    },
    {
      image: Image1,
      title: "فرایند آنلاین",
      subTitle: "بدون نیاز به رفتن بانک ، فرایندهات رو آنلاین انجام بده"
    },
    {
      image: Location,
      title: "پوشش کل کشور",
      subTitle: "از هر کجای ایران که باشی ، می تونی از شبکه پذیرندگان جت وام به صورت حضوری و آنلاین خرید کنی"
    }
  ]

  return (
    <Box sx={{ mt: 5 }}>
      <Stack direction='row' alignItems='center' spacing={1} justifyContent='center'>
        <Typography
          variant='h5'
          fontWeight='bold'
          sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
          textAlign='center'
        >
          به سرعت جت وام بگیرید
        </Typography>
      </Stack>
      <Box sx={{ mt: 4, mx: 1 }}>
        <Swiper
          loop={true}
          style={{ height: 320 }}
          spaceBetween={20}
          pagination={{
            dynamicBullets: true
          }}
          modules={[Pagination]}
        >
          {items?.map((item, index) => (
            <SwiperSlide key={index}>
              <MainCard shadow={0} sx={{ background: "transparent", borderRadius: "15px", p: 2.5 }}>
                <Stack direction='row' justifyContent='center'>
                  <Image width={100} src={item?.image} alt={item.title} />
                </Stack>
                <Stack spacing={3} mt={6}>
                  <Typography
                    variant='h5'
                    sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
                    textAlign='center'
                  >
                    {item?.title}
                  </Typography>
                  <Typography textAlign='center'>{item?.subTitle}</Typography>
                </Stack>
              </MainCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  )
}

export default MobileSimplifyBorrowing
